import React, { useEffect, useState } from "react";

import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import SupportHttp from "../../../hooks/support-http";
import { toast } from "react-toastify";

const Billing = (props) => {
  const [renewClose, setRenewClose] = useState(false);
  const [renewalDetail, setRenewalDetail] = useState();
  const [data, setData] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState();
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "20%",
      left: "30%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "390px",
      height: "390px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const { sendRequest: getProducts } = SupportHttp();

  const getAllPro = () => {
    getProducts(
      {
        url: `/api/subscription/?customerCode=${localStorage.getItem(
          "orgCode"
        )}`,
      },
      (res) => {
        //  //console.log(res[0].subscriptionDetails);

        setData(res[0].subscriptionDetails);
        setSubscriptionId(res[0].subscriptionId);
      }
    );
  };

  useEffect(() => {
    getAllPro();
  }, []);

  useEffect(() => {
    setRenewalDetail(data);
  }, [data]);

  const handleUserChange = (e, index, newValue) => {
    e.preventDefault();
    const updatedRenewalDetail = [...renewalDetail];
    updatedRenewalDetail[index].noOfUsers = newValue;
    updatedRenewalDetail[index].amount = "0";
    setRenewalDetail(updatedRenewalDetail);
  };

  const { sendRequest: postRenewal } = SupportHttp();

  const handleSubmit = (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const day = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();

    const formattedDate = `${month.toString().padStart(2, "0")}/${day
      .toString()
      .padStart(2, "0")}/${year}`;

    const input = {
      dateOfRequest: formattedDate,
      dateOfConfirm: formattedDate,
      subscriptionRenewalDetail: renewalDetail,
      status: 1,
      totalAmount: "0",
      subscriptionId: subscriptionId,
      currencyId: "",
    };

    // //console.log(input);
    postRenewal(
      {
        url: "/api/subscriptionRenewal/",
        method: "POST",

        body: input,
      },
      (data) => {
        //   //console.log(data);
        toast.success("Request send Successfully");
      },
      (error) => {
        console.error("Error:", error);
        toast.error("Error");
      }
    );
  };
  const [itemsPerPage] = useState(10);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      {renewClose && (
        <Modal isOpen={true} style={modalStyles}>
          <h3>Renew Request</h3>

          <form onSubmit={handleSubmit}>
            <table className="table table-bordered text-center">
              <thead>
                <tr className="">
                  <th>Sr No</th>
                  <th>Product Name</th>
                  <th>Subscription Start Date</th>
                  <th>Subscription End Date</th>
                  <th>No OF User</th>
                </tr>
              </thead>
              <tbody>
                {renewalDetail &&
                  renewalDetail.map((itm, i) => {
                    return (
                      <tr key={i} className="tablerowview">
                        <td>{i + 1}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.dateOfStart}</td>
                        <td>{itm.dateOfEnd}</td>

                        <td>
                          <input
                            type={"number"}
                            id={"title"}
                            className="form-control"
                            defaultValue={itm.noOfUsers}
                            onChange={(e) =>
                              handleUserChange(e, i, e.target.value)
                            }
                          />
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <div className="flexRow" style={{ margin: "10px" }}>
              <button type="submit" className="btn btn-primary">
                Send Request
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-success"
                onClick={() => {
                  setRenewClose(false);
                }}
              >
                Cancel
              </button>
            </div>
          </form>

          <br />
        </Modal>
      )}
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Your Products & licenses
            </label>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Product Name</th>
                          <th>Subscription Start Date</th>
                          <th>Subscription End Date</th>
                          <th>No OF User</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{x.productName}</td>
                                <td>{x.dateOfStart}</td>
                                <td>{x.dateOfEnd}</td>

                                <td>{x.noOfUsers}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  <div className="col-6 mb-2">
                    <button
                      type="button"
                      onClick={() => setRenewClose(true)}
                      className="btn btn-warning"
                    >
                      Renew Request
                    </button>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Billing;
